export const COLLECTING = 'collecting'
export const DUCKING = 'ducking'
export const CROSSING_GUARD = 'crossingGuard'
